function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { includes } from 'lodash';
import { withModifiers } from '../../decorators';
import { genId } from '../../helpers/generator';
import Text from '../text';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var Radio = function Radio(_ref) {
  var Tag = _ref.asTag,
      checked = _ref.checked,
      className = _ref.className,
      cta = _ref.cta,
      disabled = _ref.disabled,
      forceControl = _ref.forceControl,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? genId() : _ref$id,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      onChange = _ref.onChange,
      _onClick = _ref.onClick,
      value = _ref.value,
      tabIndex = _ref.tabIndex,
      others = _objectWithoutProperties(_ref, ["asTag", "checked", "className", "cta", "disabled", "forceControl", "id", "label", "labelClassName", "onChange", "onClick", "value", "tabIndex"]);

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      _checked = _useState2[0],
      setChecked = _useState2[1];

  var classes = classNames('input is-checkradio is-info is-hidden', className, {
    'has-background-color': className && !includes(className, 'is-inverted')
  });
  var labelClasses = classNames(labelClassName, {
    'has-text-info': checked
  });
  var isChecked = forceControl ? checked : _checked;

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, {
    className: "field is-tri"
  }, React.createElement(Radio.Control, {
    asTag: getValidNestedChild(_contextNested.isNestedInParent, _Tag),
    className: classNames('control', {
      'is-disabled': disabled
    })
  }, React.createElement("input", _extends({
    className: classes,
    type: "radio",
    readOnly: forceControl
  }, {
    id: id,
    disabled: disabled,
    value: value,
    checked: isChecked,
    tabIndex: tabIndex
  }, others)), React.createElement("label", {
    htmlFor: id,
    className: labelClasses,
    onClick: function onClick(e) {
      if (!forceControl) setChecked(!_checked); // e.target.id = id

      e.target.value = value;
      e.target.checked = isChecked;

      if (onChange) {
        onChange(e, {
          id: id,
          checked: isChecked,
          value: value
        });
      }

      _onClick && _onClick(e);
    }
  }, label && typeof label.valueOf() === 'string' ? React.createElement(Radio.Text, {
    asTag: "span"
  }, label) : React.createElement(Radio.Text, {
    asTag: "div"
  }, label)), cta && React.createElement(React.Fragment, null, typeof cta.valueOf() === 'string' ? React.createElement(Radio.Text, {
    asTag: "span",
    content: cta
  }) : cta))));
};

Radio.propTypes = {
  label: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  id: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  forceControl: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  cta: PropTypes.any,
  value: PropTypes.any,
  tabIndex: PropTypes.number,
  asTag: PropTypes.string
};
Radio.defaultProps = {
  asTag: 'div',
  tabIndex: 0
};
Radio.Control = Text;
Radio.Text = Text;
export default withModifiers(Radio);